export default "__VITE_ASSET__C$U_v4Fb__"